import React from 'react'

const RestPage = () => {
    return (
        <>
            <div className='w-full bg-red-200 h-[500px] rounded-xl my-10'></div>
            <div className='w-full bg-green-200 h-[500px] rounded-xl my-10'></div>
            <div className='w-full bg-blue-200 h-[500px] rounded-xl my-10'></div>
        </>
    )
}

export default RestPage
